import React from 'react';
import { Grid, Card, createStyles, makeStyles, Theme } from '@material-ui/core';
import { useIsMobile } from '../../../../../util/style-utils';
import BottomDrawerLayout, {
  DrawerSnapType,
} from '../../bottom-drawer-layout/BottomDrawerLayout';
import clsx from 'clsx';
import useOutageMapNotificationVisiblity from '../../../../../hooks/useOutagesMapNotificationVisiblity';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    outageMapPanel: {
      width: '19rem',
      position: 'absolute',
      top: '20px',
      left: '15px',
      padding: '1rem',
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'nowrap',
      background: '#fff',
      boxShadow: '0px 3px 6px #00000029',
      borderRadius: '5px',
      maxHeight: 'calc(100vh - 100px)',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        top: 'auto',
        left: 'auto',
        bottom: 0,
      },
      transition: 'top .30s linear',
    },
    outageMapMainPanel: {
      bottom: 'auto',
    },
    rightAlignPanel: {
      left: 'auto',
      right: '10px',
      width: '320px',
      overflow: 'auto',
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
      [theme.breakpoints.up('sm')]: {
        maxHeight: '95%',
      },
    },
  }),
);

type Props = {
  children: React.ReactNode;
  isMainPanel?: boolean;
  alignRight?: boolean;
  refId?: number;
  onClose?: () => void;
  defaultSnap?: DrawerSnapType;
  footer?: React.ReactNode;
};

const LeftPanelCard = ({ children, isMainPanel, alignRight }: Props) => {
  const classes = useStyles();
  const {
    notificationContainerHeight,
    outageGlobalMessagesContainerHeight,
    outageNotificationContainerHeight,
  } = useOutageMapNotificationVisiblity();

  return (
    <Card>
      <Grid
        container
        className={clsx(classes.outageMapPanel, {
          [classes.outageMapMainPanel]: isMainPanel,
          [classes.rightAlignPanel]: alignRight,
        })}
        style={{
          top:
            notificationContainerHeight +
            outageGlobalMessagesContainerHeight +
            outageNotificationContainerHeight +
            15,
        }}
      >
        {children}
      </Grid>
    </Card>
  );
};

export default function OutagePanelLayout({
  children,
  isMainPanel = false,
  alignRight,
  refId,
  onClose,
  defaultSnap,
  footer,
}: Props) {
  const isMobileView = useIsMobile();
  return isMobileView ? (
    <BottomDrawerLayout
      onClose={onClose}
      refId={refId}
      isOpen
      defaultSnap={defaultSnap}
      data-testid="outage-panel-mobile"
      footer={footer}
    >
      {children}
    </BottomDrawerLayout>
  ) : (
    <LeftPanelCard
      isMainPanel={isMainPanel}
      alignRight={alignRight}
      data-testid="outage-panel-desktop"
    >
      {children}
    </LeftPanelCard>
  );
}
